// FONT WEIGHT
export const FONT_WEIGHT_THIN = 300;
export const FONT_WEIGHT = 400;
export const FONT_WEIGHT_MEDIUM = 600;
export const FONT_WEIGHT_BOLD = 700;

// FONT FAMILY
export const FONT_FAMILY_THIN = "Open Sans Thin";
export const FONT_FAMILY_REGULAR = "Open Sans";
export const FONT_FAMILY_MEDIUM = "Open Sans Medium";
export const FONT_FAMILY_BOLD = "Open Sans Bold";
